import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { stringToParsedTokenArray } from "@poscon/shared-types/eram";
import { sectorIdSelector } from "../slices/connectionSlice";
import { EramPrompt } from "./EramPrompt";
import { eramFontNameMap, eramTextDimensionMap } from "../../eramFont";
import { useRootSelector } from "../stateSelectors";
import { MenuElement } from "./MenuElement";
import { colorNameMap } from "../../colorNameMap";
import { EramInput, useInputProps } from "./EramInput";
import { TRIANGLE_DOWN_FILLED, TRIANGLE_DOWN_OUTLINE, typedSplitString } from "@poscon/shared-types";
import { createItemOption, ViewItemOptionContainer } from "./ViewItemOptionContainer";
import { selectedViewOptionSelector, setSelectedViewOption, toggleSelectedViewOption } from "../slices/commonSlice";
export const cpdlcTocHeldView = "CPDLC_TOC_HELD";
const fontFamily = eramFontNameMap[2];
const fontDim = eramTextDimensionMap[2];
const tint = colorNameMap.lightGrey;
const width = fontDim.width * 28;
const freqInputX = fontDim.width * 17;
const freqInputWidth = fontDim.width * 6 + 4;
const freqTriggerX = freqInputX + freqInputWidth + 3;
const HeldTocRow = ({ fp, msg, y, dispatchCommand }) => {
    const dispatch = useDispatch();
    const selectedItem = useRootSelector(selectedViewOptionSelector);
    const inputProps = useInputProps(`${cpdlcTocHeldView}/row/${fp.id}`, msg.nextSectorFrequency?.slice(0, 6) ?? "", undefined, {
        resetOnMouseDown: true,
        maxLength: 6,
    });
    const uplinkToc = () => {
        dispatchCommand(stringToParsedTokenArray(`UH ${msg.nextSectorIdShort} ${inputProps.value} ${fp.cid ?? fp.callsign}`));
    };
    // TODO: implement error messages and coding when input is invalid or uplink is not selectable, see TI6110.100 page 7-16
    const freqPath = `${cpdlcTocHeldView}/row/${fp.id}/freq`;
    const hasFreqPresets = msg.nextSectorFrequencies.length > 1;
    const freqDropdownOpen = hasFreqPresets && selectedItem === freqPath;
    return (_jsxs("container", { y: y, zIndex: freqDropdownOpen ? 5 : undefined, children: [_jsx(MenuElement, { x: 3, y: 2, text: msg.nextSectorIdShort, fillColor: 0, borderColor: 0, tint: tint, onmousedown: uplinkToc }), _jsx(EramInput, { x: freqInputX, y: 2, borderTint: colorNameMap.mediumGrey, width: freqInputWidth, highlightColor: colorNameMap.white, ...inputProps }), hasFreqPresets && (_jsx(MenuElement, { x: freqTriggerX, text: freqDropdownOpen ? TRIANGLE_DOWN_FILLED : TRIANGLE_DOWN_OUTLINE, width: fontDim.width + 5, height: fontDim.height + 2, fillColor: 0, borderColor: colorNameMap.mediumGrey, tint: tint, onmousedown: () => dispatch(toggleSelectedViewOption(freqPath)) })), freqDropdownOpen && (_jsx(ViewItemOptionContainer, { baseX: freqInputX, baseY: 2, yOffset: fontDim.height + 3, options: msg.nextSectorFrequencies.map((freq) => createItemOption(freq, () => {
                    inputProps.setInputValue(freq);
                    dispatch(setSelectedViewOption(null));
                }, { isDefaultSelection: freq === inputProps.value })) }))] }));
};
export const CpdlcTocHeld = ({ fp, session, dispatchCommand, ref, ...promptProps }) => {
    const sectorId = useRootSelector(sectorIdSelector);
    const isEligible = session.eligibleSectorId === sectorId;
    const messages = session.heldTOCs.filter((toc) => sectorId && toc.originator?.startsWith(typedSplitString(sectorId, ".")[0]));
    const height = messages.length * (fontDim.height + 6) + 2 + fontDim.height + 3;
    let y = fontDim.height + 3;
    const showView = messages.length > 0 && isEligible;
    useEffect(() => {
        if (!showView) {
            promptProps.closeMenu();
        }
    }, [showView, promptProps.closeMenu]);
    return (showView && (_jsxs(EramPrompt, { ref: ref, title: fp.callsign, width: width, height: height, borderTint: colorNameMap.veryDarkGrey, showX: true, ...promptProps, children: [_jsx(MenuElement, { y: -1, width: width, text: "HELD TOC", disabled: true, tint: colorNameMap.lightGrey }), messages.map((msg) => {
                const _y = y;
                y += fontDim.height + 6;
                return _jsx(HeldTocRow, { fp: fp, msg: msg, y: _y, dispatchCommand: dispatchCommand }, msg.id);
            })] })));
};
//# sourceMappingURL=CpdlcTocHeld.js.map